import { render, staticRenderFns } from "./AddAdditionalCompanyDialog.vue?vue&type=template&id=5a16896a&"
import script from "./AddAdditionalCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalCompanyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports